import React, { FunctionComponent } from "react";
import {
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBBtn,
} from "mdbreact";
import QRCodeSVG from "presentation/components/QRCodeSVG";

interface WalletQRCodeModalProps {
  isOpen: boolean;
  title: string;
  url: string;
  onClose: () => void;
}

const WalletQRCodeModal: FunctionComponent<WalletQRCodeModalProps> = ({
  isOpen,
  title,
  url,
  onClose,
}) => {
  return (
    <MDBModal
      isOpen={isOpen}
      toggle={onClose}
      inline={false}
      noClickableBodyWithoutBackdrop={false}
      overflowScroll={false}
      centered
    >
      <MDBModalHeader toggle={onClose} className="border-0">
        {title}
      </MDBModalHeader>
      <MDBModalBody className="d-flex flex-column align-items-center py-3">
        <p className="text-center mb-3">
          Scan this QR code with your phone to add the card to your wallet.
        </p>
        <QRCodeSVG value={url} size={200} />
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 text-center"
          style={{ fontSize: "0.85rem", wordBreak: "break-all" }}
        >
          Open link directly
        </a>
      </MDBModalBody>
      <MDBModalFooter className="border-0">
        <MDBBtn onClick={onClose} className="btn-flat text-primary px-3 py-2">
          Close
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  );
};

export default WalletQRCodeModal;
